import React, { useContext, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { AuthContext } from '../../common/constants';
import { UserService } from '../../common/services';
import { Button } from '../../components';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import Logo from '../../layout/logo/tigoon-connect-logo.png';

const Login = () => {

    const auth = useContext(AuthContext);
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState({ phone: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);

    const handleLogin = async () => {
        try {
            setLoading(true);
            const formattedData = {
                ...data,
                phone: `+225${data.phone}`,
            };
            const response = await UserService.signin(formattedData);

            auth.onLogin(response, navigate);
        } catch (error) {
            const errorMessage = error.message || 'Une erreur est survenue lors de la connexion.';
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 5000,
            });
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            {/* Content */}
            <ToastContainer />
            <div className="container-xxl">
                <div className="authentication-wrapper authentication-basic container-p-y">
                    <div className="authentication-inner">

                        <div className="card">
                            <div className="card-body">

                                {/* Logo */}
                                <div className="app-brand justify-content-center">
                                    <a href="/" className="app-brand-link gap-2">
                                        <span className="app-brand-logo demo">
                                            <img src={Logo} alt="logo" width="100" height="100" />
                                        </span>
                                    </a>
                                </div>
                                {/* /Logo */}
                                <h4 className="mb-2">Bienveue sur TIGOON Connect !</h4>
                                <p className="mb-4">
                                    Veuillez vous connecter à votre compte et commencer l'aventure
                                </p>

                                <div className="mb-3 ">
                                    <label htmlFor="email" className="form-label">
                                        Numéro de téléphone
                                    </label>
                                    <div className="input-group">
                                        <span className="input-group-text">+225</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="phone"
                                            name="phone"
                                            placeholder="0747247147"
                                            value={data.phone}
                                            onChange={({ target }) => {
                                                // Ne garder que les chiffres (optionnel pour empêcher erreurs)
                                                const value = target.value.replace(/\D/g, '');
                                                setData({ ...data, phone: value });
                                            }}
                                        />
                                    </div>

                                </div>
                                <div className="mb-3 form-password-toggle">
                                    <div className="d-flex justify-content-between">
                                        <label className="form-label" htmlFor="password">
                                            Mot de passe
                                        </label>
                                    </div>

                                    <div className="input-group input-group-merge">
                                        {/* Icône cadenas à gauche */}
                                        <span className="input-group-text">
                                            <i className="bx bx-lock" />
                                        </span>

                                        {/* Champ mot de passe */}
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            id="password"
                                            className="form-control"
                                            name="password"
                                            placeholder="············"
                                            aria-describedby="password"
                                            value={data.password}
                                            onChange={({ target }) => setData(data => ({ ...data, password: target.value }))}
                                            autoComplete="current-password"
                                        />

                                        {/* Icône de visibilité à droite */}
                                        <span
                                            className="input-group-text cursor-pointer"
                                            onClick={() => setShowPassword(prev => !prev)}
                                        >
                                            <i className={`bx ${showPassword ? 'bx-show' : 'bx-hide'}`} />
                                        </span>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="remember-me"
                                        />
                                        <label className="form-check-label" htmlFor="remember-me">
                                            Se souvenir de moi
                                        </label>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <Button className="btn btn-primary d-grid w-100" {...{ isLoading }} onClick={handleLogin}> se connecter
                                    </Button>
                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>

    );
}

export default Login;
